let gallerySlideshowSwiper = new Swiper('.gallery-display-as-slideshow .swiper', {
	slidesPerView: 'auto',
	spaceBetween:  16,
	speed:         500,
	autoHeight:    true,
	pagination:    {
		el:        ".swiper-pagination",
		clickable: true
	},
	/*loop:          true,
	autoplay:      {
		delay:                3000,
		stopOnLastSlide:      false
	},*/
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	}
});

let FHSlider = gsap.utils.toArray(".FHSlider");

FHSlider.forEach((container) => {
	let effect        = container.getElementsByClassName("effect")[0];
	let SlideEffect   = effect.dataset.effect;
	let autoplay      = container.getElementsByClassName("autoplay")[0];
	let SlideAutoplay = autoplay.dataset.autoplay;

	// let Pagination = container.getElementsByClassName("swiper-pagination")[0];
	let custom_button_next = container.getElementsByClassName("CustomNavigationArrowNext")[0];
	let custom_button_prev = container.getElementsByClassName("CustomNavigationArrowPrev")[0];
	const myswiper         = new Swiper(container,
		{
			/*
			pagination: {
			  el: Pagination,
			  clickable: true,
			},
			*/
			navigation:
				{
					nextEl: custom_button_next,
					prevEl: custom_button_prev,
				},
			keyboard: {
				enabled:        true,
				onlyInViewport: false,
			},
			speed:    700,
			effect:   SlideEffect,
			loop:     true,
			/*on:       {
				init: function () {
					gsap.to(container, {
						autoAlpha: 1, onComplete: () => {
							let SplitTextAnimation = gsap.utils.toArray(container.querySelectorAll(".swiper-descr-wrapper-fixedtext .swiper-descr-title > p"));
							SplitTextAnimation.forEach((textContainer) => {
								const split = new SplitText(textContainer, {type: "lines", linesClass: "line line++"});
								$(textContainer).find('.line').wrap('<div class="line-wrapper" style="overflow:hidden;"></div>');
								gsap.to(textContainer, {autoAlpha: 1, width: "100%"}); // Set opacity to 1 before animating
								gsap.from(split.lines, {
									duration: 0.6,
									y:        "120%",
									stagger:  0.3,
									delay:    0.5
								});
							});
						}
					});
				}
			}*/
		});

	if (SlideAutoplay)
	{
		myswiper.autoplay.start();
	}
});


let prossimiViaggiSwiper = new Swiper('.block-prossimi-viaggi .swiper', {
	slidesPerView:      'auto',
	spaceBetween:       16,
	slidesOffsetBefore: 16,
	slidesOffsetAfter:  16,
	navigation:         {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	/*pagination:    {
		el:        ".swiper-pagination",
		clickable: true
	},*/
	breakpoints: {
		1600: {
			spaceBetween:       16,
			slidesOffsetAfter:  24,
			slidesOffsetBefore: (() => {
				return window.visualViewport.width / 12 + 24;
			})(),
		}
	}
});

let calendarioPartenzeSwiper = new Swiper('.block-calendario-partenze .swiper', {
	slidesPerView:      'auto',
	spaceBetween:       16,
	slidesOffsetBefore: 16,
	slidesOffsetAfter:  16,
	navigation:         {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	/*pagination:    {
		el:        ".swiper-pagination",
		clickable: true
	},*/
	breakpoints: {
		1600: {
			spaceBetween:       16,
			slidesOffsetAfter:  24,
			slidesOffsetBefore: (() => {
				return window.visualViewport.width / 12 + 24;
			})(),
		}
	}
});

let upsellsSwiper = new Swiper('.up-sells .swiper', {
	slidesPerView:      'auto',
	spaceBetween:       16,
	slidesOffsetBefore: 16,
	slidesOffsetAfter:  16,
	navigation:         {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	/*pagination:    {
		el:        ".swiper-pagination",
		clickable: true
	},*/
	breakpoints: {
		1600: {
			spaceBetween:       16,
			slidesOffsetAfter:  24,
			slidesOffsetBefore: (() => {
				return window.visualViewport.width / 12 + 24;
			})(),
		}
	}
});


let viaggioSwiper = new Swiper('.viaggio-slideshow .swiper', {
	slidesPerView:     'auto',
	spaceBetween:      16,
	slidesOffsetBefore: 16,
	slidesOffsetAfter: 16,
	navigation:        {
		nextEl: '.viaggio-slideshow .swiper-button-next',
		prevEl: '.viaggio-slideshow .swiper-button-prev',
	},
	breakpoints:       {
		768: {
			slidesOffsetBefore: 24,
		},
		992: {
			slidesOffsetBefore: 0,
			spaceBetween:      16,
			slidesOffsetAfter: 24,
		}
	}
});